const actions = (state, payload) => (
    {
        setUser: () => {
            return { ...state, user: payload }
        },
        setFlash: () => {
            return { ...state, flash: payload }
        },
        setCurrentDate: () => {
            return { ...state, currentDate: payload }
        },
        
    }
)

export default actions;